import { Alert } from './ui/alert';

type StatusBannerProps = {
  title: string;
  tone?: 'default' | 'danger';
  description?: string;
};

export const StatusBanner = ({ title, tone = 'default', description }: StatusBannerProps) => {
  const toneClass =
    tone === 'danger'
      ? 'border-destructive/30 bg-destructive/10 text-destructive'
      : 'border-primary/25 bg-primary/10 text-foreground';

  return (
    <Alert className={toneClass}>
      <p className="font-semibold">{title}</p>
      {description ? <p className="mt-1 whitespace-pre-wrap break-words opacity-80">{description}</p> : null}
    </Alert>
  );
};
